import { getAmpConfig } from 'shared/config/amp-config';

export const getCurriculumUnitLink = (unitKey: string) =>
  `${getAmpConfig().apps}/curriculum/#/unit/${unitKey}`;

export const getUnitName = (chapterTitle: string) => {
  if (!chapterTitle) return '';
  const split = chapterTitle.split(':');
  return split[1] ? split[0] : chapterTitle;
};
